import React, {useRef, useState, useEffect} from "react";
import "../../GlobalStyles.css";
import Loader from "../../Loader/Loader";
import {useLoading} from "../../../context/LoadingContext";
import {useLocation, useNavigate} from "react-router-dom";
import {useAuth} from "../../../context/AuthContext";
import EvergentErrors from "../../../services/Evergent/EvergentErrors.ts";
import PopUp from "../../Utilities/PopUp";
import GenericError from "../../Utilities/GenericError";
import {useTranslation} from "react-i18next";
import {useProductFlowContext} from "../../../context/ProductFlowContext";


const EvergentForm = () => {
  const {t} = useTranslation();
  const navigate = useNavigate()

  const [iframeUrl, setIframeUrl] = useState(undefined);

  const formRef = useRef(null)

  const { isLoading, addLoading, removeLoading } = useLoading();
  const {loggedIn} = useAuth()

  const { resetFlow } = useProductFlowContext()

  const location = useLocation();
  const { uri } = location.state || {};

  const [genericError, setGenericError] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);

  function handleMessage(event){
    console.log(event)
    const iframeUrl = new URL(uri);
    if (!iframeUrl || (event.origin !== iframeUrl?.origin && event.origin !== window.location.origin)) {
      return;
    }

    let data;
    try {
      data = JSON.parse(event.data);
    }catch (e){
      data = event.data;
    }
    if(data?.status !== undefined){
      if((parseInt(data?.status) === 1)){

      }else if(parseInt(data.status) === 0){
        switch(data.errorCode){
          case EvergentErrors.REQUEST_TERMINATED.value:
            console.debug("Request Terminated By User");
            break;
          case EvergentErrors.REQUEST_TAMPERED.value:
            console.debug("Error: Request Tampered")
            setErrorMessage(EvergentErrors.REQUEST_TAMPERED.getKey())
            setGenericError(true);
            break;
          case EvergentErrors.CARDINFO_NO_COUNTRY.value:
            console.debug("Error: Card info no country")
            setErrorMessage(EvergentErrors.CARDINFO_NO_COUNTRY.getKey())
            setGenericError(true);
            break;
          case EvergentErrors.OLD_SKU_MISMATCH.value:
            console.debug("Error: Old SKU mismatch")
            setErrorMessage(EvergentErrors.OLD_SKU_MISMATCH.getKey())
            setGenericError(true);
            break;
          case EvergentErrors.SERVICE_VERIFICAION_FAILED.value:
            console.debug("Error: Service verification failed")
            setErrorMessage(EvergentErrors.SERVICE_VERIFICAION_FAILED.getKey())
            setGenericError(true);
            break;
          case EvergentErrors.MISSING_MANDATORY_INFO.value:
            console.debug("Error: Missing mandatory info")
            setErrorMessage(EvergentErrors.MISSING_MANDATORY_INFO.getKey())
            setGenericError(true);
            break;
          case EvergentErrors.EXPIRED_CARD.value:
            console.debug("Error: Expired card")
            setErrorMessage(EvergentErrors.EXPIRED_CARD.getKey())
            setGenericError(true);
            break;
          case EvergentErrors.DOWNGRADE_ALREADY_SCHEDULED.value:
            console.debug("Request Downgrade already scheduled");
            setErrorMessage(EvergentErrors.DOWNGRADE_ALREADY_SCHEDULED.getKey())
            setGenericError(true);
            break;
          case EvergentErrors.SERVICE_INFO_NOT_FOUND.value:
            console.debug("Error: Service info not found");
            setErrorMessage(EvergentErrors.SERVICE_INFO_NOT_FOUND.getKey())
            setGenericError(true);
            break;
          case EvergentErrors.ADDON_NOT_ALLOWED_COMBINED.value:
            console.debug("Error: Combined Purchase (SVOD + DAZN) using CY Card.");
            setErrorMessage(EvergentErrors.ADDON_NOT_ALLOWED_COMBINED.getKey())
            setGenericError(true);
            break;
          case EvergentErrors.ADDON_NOT_ALLOWED.value:
            console.debug("Error: DAZN Add-on Purchase Using CY Card.");
            setErrorMessage(EvergentErrors.ADDON_NOT_ALLOWED.getKey())
            setGenericError(true);
            break;
          default:
            console.debug("Not recognized error occurred: ", data);
            setErrorMessage("GENERIC")
            setGenericError(true);
            break;
        }
      }
    }
  }

  useEffect(()=>{
    return ()=>{
      window.postMessage({status: 400}, window.location.origin);
      window.removeEventListener("message", handleMessage)
      resetFlow()
    }
  }, [])

  useEffect(() => {
    if(!(isLoading("INIT"))){
      addLoading("INIT")
    }
    if(loggedIn){
      if(!uri || iframeUrl){
        navigate(-1);
      }else{
        setIframeUrl(new URL(uri));
        window.addEventListener("message", handleMessage)
        removeLoading("INIT")
      }
    }

  }, [loggedIn, location]); //eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (formRef.current && iframeUrl) {
      formRef.current.submit()
    }
  }, [iframeUrl]); //eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      {isLoading() && !iframeUrl ? (
        <Loader />
      ) : (
          <>
            <div style={{flex: 1, display: "flex"}}>
              <form hidden={true}
                    target={"ev-iframe"}
                    action={!!iframeUrl ? iframeUrl?.origin + iframeUrl?.pathname : ""}
                    method={"POST"} ref={(reference) => formRef.current = reference}>
                {iframeUrl && iframeUrl.search
                    .replace("?", "")
                    .split("&")
                    .map((token) => {
                      const tokens = token.split("=")
                      return <input key={tokens[0]} name={tokens[0]} defaultValue={tokens[1]}/>
                    })}
              </form>
              {iframeUrl && <iframe name={"ev-iframe"} title={"ev-add-payment-method"} src={iframeUrl}
                                    style={{width: '100%', height: '100vh', border: 'none'}}
              />}
            </div>
            <PopUp
                openPopUp={genericError}
                setOpenPopUp={setGenericError}
                maxWidth="md"
                showCloseButton={false}
                outlined={false}
                error={true}
                closeWhenClickedOutside={false}>
              <GenericError
                  setClose={setGenericError}
                  buttonText={t("cartPageGenericErrorCTA")}
                  executeFunction={function () {
                    switch(errorMessage) {
                      case EvergentErrors.ADDON_NOT_ALLOWED_COMBINED.getKey():
                        navigate("/PickProgram");
                        break;
                      case EvergentErrors.ADDON_NOT_ALLOWED.getKey():
                        navigate("/PickProgram");
                        break;
                      default:
                        navigate(-1);
                    }
                  }}
                  mainText={t("cartPageGenericErrorTitle."+errorMessage, { defaultValue: t("cartPageGenericErrorTitle") })}
                  showIcon={false}>
                <span className={"pick-program-fallback-modal"}>
                    {t("cartPageErrorMessage."+errorMessage)}
                </span>
              </GenericError>
            </PopUp>
          </>
  )}
    </>
  );
};

export default EvergentForm;